<template>
  <div class="base-sidebar h-full bg-white border rounded-lg">
    <div class="sidebar-content h-full flex flex-col">
      <div v-if="showHeader" class="sidebar-header p-4 border-b">
        <div class="flex items-center justify-between">
          <button
            v-if="showBackButton"
            @click="handleBack"
            class="flex cursor-pointer gap-x-1 text-eblack-600"
          >
            <svg
              class="w-6 h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"
              />
            </svg>
            <span>{{ backText }}</span>
          </button>
          <h3 v-if="title" class="text-lg font-medium text-gray-900">
            <slot name="header">{{ title }}</slot>
          </h3>
          <button
            v-if="showCloseButton && !showBackButton"
            @click="handleClose"
            class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <div class="sidebar-body flex-1 overflow-y-auto">
        <slot></slot>
      </div>

      <div v-if="showFooter" class="sidebar-footer p-4 border-t">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSidebar',
  props: {
    title: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    showBackButton: {
      type: Boolean,
      default: true
    },
    backText: {
      type: String,
      default: 'Cerrar'
    }
  },
  emits: ['close', 'back'],
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleBack() {
      this.$emit('back');
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.base-sidebar {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.sidebar-content {
  width: 100%;
  height: 100%;
}

.sidebar-body {
  padding: 1rem;
}
</style>